var map = {
	"./ad.png": 7683,
	"./ae.png": 6106,
	"./af.png": 769,
	"./ag.png": 824,
	"./al.png": 7403,
	"./am.png": 8402,
	"./ao.png": 8720,
	"./ar.png": 6149,
	"./at.png": 8131,
	"./au.png": 2922,
	"./az.png": 9517,
	"./ba.png": 3599,
	"./bb.png": 6740,
	"./bd.png": 5778,
	"./be.png": 603,
	"./bf.png": 2272,
	"./bg.png": 393,
	"./bh.png": 878,
	"./bi.png": 3367,
	"./bj.png": 716,
	"./bm.png": 611,
	"./bn.png": 3752,
	"./bo.png": 7617,
	"./br.png": 5764,
	"./bs.png": 6893,
	"./bt.png": 5170,
	"./bw.png": 8105,
	"./by.png": 8215,
	"./bz.png": 4284,
	"./ca.png": 7048,
	"./cd.png": 1253,
	"./cf.png": 6663,
	"./cg.png": 8497,
	"./ch.png": 281,
	"./chandneighbours.png": 7994,
	"./ci.png": 6080,
	"./ck.png": 2098,
	"./cl.png": 2077,
	"./cm.png": 8836,
	"./cn.png": 4111,
	"./co.png": 310,
	"./cr.png": 8979,
	"./cu.png": 5372,
	"./cv.png": 4103,
	"./cy.png": 272,
	"./cz.png": 5675,
	"./dach.png": 9500,
	"./de.png": 1981,
	"./dj.png": 2122,
	"./dk.png": 9699,
	"./dm.png": 8629,
	"./do.png": 9591,
	"./dz.png": 1146,
	"./ec.png": 8912,
	"./ee.png": 2742,
	"./eg.png": 2852,
	"./eh.png": 8771,
	"./en.png": 8229,
	"./er.png": 2601,
	"./es.png": 7776,
	"./et.png": 2751,
	"./eu.png": 2774,
	"./fi.png": 7739,
	"./fj.png": 9056,
	"./fm.png": 7711,
	"./fr.png": 2712,
	"./ga.png": 6012,
	"./gb.png": 4119,
	"./gd.png": 6257,
	"./ge.png": 5128,
	"./gh.png": 8621,
	"./gm.png": 4208,
	"./gn.png": 5499,
	"./gq.png": 268,
	"./gr.png": 8743,
	"./gt.png": 3521,
	"./gw.png": 8858,
	"./gy.png": 6564,
	"./hk.png": 5655,
	"./hn.png": 5770,
	"./hr.png": 7974,
	"./ht.png": 1120,
	"./hu.png": 7369,
	"./id.png": 4827,
	"./ie.png": 3698,
	"./il.png": 211,
	"./in.png": 5585,
	"./iq.png": 1366,
	"./ir.png": 2045,
	"./is.png": 5892,
	"./it.png": 5835,
	"./je.png": 8691,
	"./jm.png": 3307,
	"./jo.png": 9945,
	"./jp.png": 126,
	"./ke.png": 3383,
	"./kg.png": 9478,
	"./kh.png": 9281,
	"./ki.png": 6568,
	"./km.png": 7452,
	"./kn.png": 6183,
	"./kp.png": 8713,
	"./kr.png": 5723,
	"./kw.png": 2390,
	"./kz.png": 1107,
	"./la.png": 4865,
	"./lb.png": 106,
	"./lc.png": 7859,
	"./li.png": 7641,
	"./lk.png": 7851,
	"./lr.png": 3370,
	"./ls.png": 8931,
	"./lt.png": 1532,
	"./lu.png": 3797,
	"./lv.png": 5966,
	"./ly.png": 5353,
	"./ma.png": 5786,
	"./mc.png": 5736,
	"./md.png": 7879,
	"./me.png": 8382,
	"./mg.png": 3948,
	"./mh.png": 5339,
	"./mk.png": 1520,
	"./ml.png": 6895,
	"./mm.png": 5350,
	"./mn.png": 6557,
	"./mr.png": 7281,
	"./mt.png": 3031,
	"./mu.png": 542,
	"./mv.png": 6293,
	"./mw.png": 380,
	"./mx.png": 267,
	"./my.png": 5442,
	"./mz.png": 57,
	"./na.png": 5163,
	"./ne.png": 9743,
	"./ng.png": 8285,
	"./ni.png": 547,
	"./nl.png": 8206,
	"./no.png": 8565,
	"./no_flag.png": 7192,
	"./np.png": 818,
	"./nr.png": 1136,
	"./nu.png": 9791,
	"./nz.png": 3240,
	"./om.png": 7736,
	"./pa.png": 7301,
	"./pe.png": 8289,
	"./pg.png": 1283,
	"./ph.png": 7412,
	"./pk.png": 4271,
	"./pl.png": 2944,
	"./ps.png": 8887,
	"./pt.png": 6744,
	"./pw.png": 2355,
	"./py.png": 7565,
	"./qa.png": 1806,
	"./ro.png": 9345,
	"./rs.png": 5805,
	"./ru.png": 9595,
	"./rw.png": 1766,
	"./sa.png": 4952,
	"./sb.png": 9443,
	"./sc.png": 4234,
	"./sd.png": 8901,
	"./se.png": 5836,
	"./sg.png": 7102,
	"./si.png": 9584,
	"./sk.png": 8306,
	"./sl.png": 4653,
	"./sm.png": 3524,
	"./sn.png": 2431,
	"./so.png": 3414,
	"./sr.png": 2787,
	"./ss.png": 5210,
	"./st.png": 1717,
	"./sv.png": 2679,
	"./sy.png": 8448,
	"./sz.png": 427,
	"./td.png": 9524,
	"./tg.png": 1983,
	"./th.png": 328,
	"./tj.png": 4058,
	"./tl.png": 1212,
	"./tm.png": 8725,
	"./tn.png": 6302,
	"./to.png": 9943,
	"./tr.png": 7938,
	"./tt.png": 4676,
	"./tv.png": 2502,
	"./tw.png": 9951,
	"./tz.png": 5034,
	"./ua.png": 1826,
	"./ug.png": 7236,
	"./us.png": 4880,
	"./uy.png": 6346,
	"./uz.png": 6929,
	"./va.png": 1459,
	"./vc.png": 625,
	"./ve.png": 1639,
	"./vn.png": 9188,
	"./vu.png": 6791,
	"./ws.png": 3886,
	"./xk.png": 967,
	"./ye.png": 4850,
	"./za.png": 9783,
	"./zm.png": 9099,
	"./zw.png": 5041
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3535;